

























import { Page } from '@/core/components/controls';
import { getTableCaption, Table, TableOptions } from '@/core/components/table';
import {
    CONTRACTS,
    Events,
    EventsServiceContract,
    FetchServiceContract,
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { User } from '@/dto';
import { ContextsState } from '@/store';
import DataSource from 'devextreme/data/data_source';
import 'devextreme/data/odata/store';
import { Component } from 'vue-property-decorator';
import UsersTable from './UsersTable.vue';

@Component({
    components: {
        UsersTable,
        TableOptions,
    },
})
export default class UsersPage extends Page {
    public table: Table | null = null;
    public tableKey: string = 'users-control';

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public setTable(table: Table): void {
        this.table = table;
    }

    public get dataSource(): DataSource {
        return new DataSource({
            key: 'id' as keyof User,
            load: this.load,
            insert: (user: User) => this.insert(user),
            update: (id: string, data: User) => this.update(id, data),
        });
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public get isRowSelected() {
        return this.table && this.table!.getSelectedRowKeys().length === 1;
    }

    public addUser() {
        this.table!.addRow();
    }

    public editUser() {
        const selectedKey = this.table!.getSelectedRowKeys()[0];

        if (selectedKey) {
            const selectedIndex = this.table!.getRowIndexByKey(selectedKey);
            this.table!.editRow(selectedIndex);
        }
    }

    private async load() {
        const url = `/users`;
        const data = await this._fetchService!.get<User[]>(url);
        if (!data) {
            return [];
        }
        return { data };
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.table!.refresh();
        }
    }

    private async insert(user: User) {
        return await this._fetchService!.post<User>('/users', {
            ...user,
            password: user.password ? user.password : null,
        });
    }

    private async update(id: string, user: User) {
        return await this._fetchService!.put<User>(`/users/${id}`, user);
    }
}
